import React from 'react';
import { Check, type Icon } from '@phosphor-icons/react';

export interface SchrittInfo { label: string; icon: Icon }

/**
 * Schrittleiste (Handoff E-Mails §9 „StepBar“): erledigte Schritte mit Haken und anklickbar,
 * der aktuelle Schritt hervorgehoben, spätere gedimmt. Ob ein Schritt anklickbar ist, entscheidet der Aufrufer.
 */
export function Schrittleiste({ schritte, aktuell, onWahl, darfWaehlen, mobil = false }: {
  schritte: readonly SchrittInfo[];
  /** 0-basiert */
  aktuell: number;
  onWahl: (i: number) => void;
  darfWaehlen: (i: number) => boolean;
  mobil?: boolean;
}) {
  return (
    <nav aria-label="Schritte" className="immo-glas flex items-center min-w-0" style={{ borderRadius: 20, padding: mobil ? 6 : '8px 12px', gap: mobil ? 4 : 10 }}>
      {schritte.map((s, i) => {
        const erledigt = i < aktuell;
        const aktiv = i === aktuell;
        const klickbar = !aktiv && darfWaehlen(i);
        const I = s.icon;
        return (
          <React.Fragment key={s.label}>
            <button type="button" onClick={() => klickbar && onWahl(i)} disabled={!klickbar && !aktiv} aria-current={aktiv ? 'step' : undefined}
              className={`flex items-center min-w-0 ${klickbar ? 'cursor-pointer' : 'cursor-default'}`}
              style={{ gap: 8, minHeight: 44, padding: '0 4px', border: 'none', background: 'transparent', color: aktiv ? 'var(--ink)' : erledigt ? 'var(--ink2)' : 'var(--ink3)', flexShrink: aktiv ? 0 : 1 }}>
              <span className="flex items-center justify-center shrink-0" style={{
                width: 32, height: 32, borderRadius: '50%',
                background: erledigt ? 'var(--ok)' : aktiv ? 'var(--acc-fill)' : 'var(--fill2)',
                color: erledigt ? '#fff' : aktiv ? 'var(--acc-ink)' : 'var(--ink3)',
              }}>
                {erledigt ? <Check size={15} weight="bold" /> : <I size={15} weight={aktiv ? 'fill' : 'regular'} />}
              </span>
              {(!mobil || aktiv) && <span className="truncate" style={{ fontSize: 13, fontWeight: aktiv ? 800 : 600 }}>{s.label}</span>}
            </button>
            {i < schritte.length - 1 && (
              <span aria-hidden className="flex-1" style={{ minWidth: 12, height: 2, borderRadius: 1, background: i < aktuell ? 'var(--ok)' : 'var(--line)' }} />
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
}
